var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useResultCategoryOutletContext } from '@/components/results-category/hooks/use-result-category-outlet-context.hook';
import { NavigationButton, NavigationButtonsContainer, } from '@/components/navigation-button.component';
import { resultCategoryImages } from '@/components/results-category/constants/results-category-images.constant';
import { HearingResultsPopup, DiscountMessage, } from '@/components/results-category/components/hearing-results-popup.component';
import { useAnalytics } from 'hx-analytics';
import { useNavigator } from 'hx-navigator';
import { sendScrollIntoView } from '@/helpers/send-scroll-into-view.helper';
function Heading() {
    return (_jsxs("span", __assign({ className: 'inline-block leading-10 text-center md:w-full max-w-2xl md:-mt-10 font-normal' }, { children: ["Your hearing test results show that you have", ' ', _jsx("span", __assign({ className: 'font-extrabold text-success' }, { children: "normal hearing." }))] })));
}
export function NormalHearingLossResults() {
    var sendButtonClick = useAnalytics().sendButtonClick;
    var navigate = useNavigator().navigate;
    useResultCategoryOutletContext({
        sideImage: resultCategoryImages.normalHearingSideImage,
        heading: _jsx(Heading, {}),
        step: 1.8,
    });
    function onFeedback() {
        sendButtonClick('feedback_click');
        navigate('/feedback');
    }
    function onShare() {
        sendButtonClick('share');
        navigate('/share-the-joy');
        sendScrollIntoView();
    }
    return (_jsxs("div", __assign({ className: 'h-full flex flex-col justify-between gap-5 px-10 w-full' }, { children: [_jsx(HearingResultsPopup, {}), _jsx(DiscountMessage, {}), _jsxs(NavigationButtonsContainer, __assign({ className: "w-full flex-col-reverse lg:flex-row items-center lg:justify-center sm:gap-4" }, { children: [_jsx(NavigationButton, __assign({ onClick: onFeedback, variant: "outlined", className: 'sm:w-full w-full' }, { children: "We'd love your feedback" })), _jsx(NavigationButton, __assign({ onClick: onShare, variant: "contained", className: 'sm:w-full w-full' }, { children: "Share the joy of better hearing" }))] }))] })));
}
